<template>
  <div class="ql-toolbar ql-snow" >
    <span v-for="(group, i) in toolbar" class="ql-formats" :key="'toolbar-group-' + i" >
      <el-tooltip
         v-for="(action, j) in group"
         placement="top"
         :content="action.title"
         :key="'toolbar-action-' + i + '-' + j + '-' + action.action" >
        <span class="select-tooltip-container" v-if="action.type === 'select'" >
          <select :class="'ql-' + action.action" ></select>
        </span>
        <button
           v-else
           type="button"
           :class="'ql-' + action.action"
           :value="action.value" >
        </button>
      </el-tooltip>
    </span>
    <span class="ql-formats" >
      <el-tooltip placement="top" content="DropBox" >
        <el-button
           type="button"
           class="ql-dropbox"
           value="dropbox"
           icon="el-icon-fa-cubes" >
        </el-button>
      </el-tooltip>
    </span>
  </div>
</template>

<style scoped>
.ql-toolbar {
    display: flex;
}
.select-tooltip-container {
    display: inline-block;
}
</style>

<script>
export default {
  data () {
    return {
      toolbar: [
        [
          {action: 'bold', title: 'Gras'},
          {action: 'italic', title: 'Italique'},
          {action: 'underline', title: 'Souligné'},
          {action: 'strike', title: 'Barré'}
        ],
        [
          {action: 'blockquote', title: 'Citation'},
          {action: 'code-block', title: 'Code'}
        ],
        [
          {action: 'header', value: '1', title: 'Titre Principal'},
          {action: 'header', value: '2', title: 'Sous-Titre'}
        ],
        [
          {action: 'list', value: 'ordered', title: 'Liste Numérotée'},
          {action: 'list', value: 'bullet', title: 'Liste'}
        ],
        [
          {action: 'indent', value: '-1', title: 'Diminuer l\'Indentation'},
          {action: 'indent', value: '+1', title: 'Augmenter l\'Indentation'}
        ],
        [
          {action: 'direction', value: 'rtl', title: 'Sens du texte'}
        ],
        [
          {action: 'size', type: 'select', title: 'Taille du Texte'}
        ],
        [
          {action: 'header', type: 'select', title: 'Titres'}
        ],
        [
          {action: 'color', type: 'select', title: 'Couleur du Texte'},
          {action: 'background', type: 'select', title: 'Couleur du Fond'}
        ],
        [
          {action: 'font', type: 'select', title: 'Type de Police'}
        ],
        [
          {action: 'align', type: 'select', title: 'Alignement'}
        ],
        [
          {action: 'link', title: 'Lien'},
          {action: 'image', title: 'Image'},
          {action: 'video', title: 'Video'}
        ]
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/blog/QuillToolbar.vue